import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import AdsAudienceLink from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceLink';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AdsAudienceMembershipActionExplainer({
  action
}) {
  const {
    audienceId,
    shouldAdd
  } = action.metadata;
  return shouldAdd ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.ads-audience-membership.explainer.shouldAdd",
    options: {
      audienceLink: /*#__PURE__*/_jsx(AdsAudienceLink, {
        id: audienceId
      })
    }
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.ads-audience-membership.explainer.shouldRemove",
    options: {
      audienceLink: /*#__PURE__*/_jsx(AdsAudienceLink, {
        id: audienceId
      })
    }
  });
}